var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-action-modal',{attrs:{"show":_vm.visible,"client-action-id":_vm.$route.params.clientActionId},on:{"update:show":function($event){_vm.visible=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }